import { ICustomerStyle } from '../../models/ICustomerStyle'
import './Error.scss'

export interface ErrorProps {
    customerStyle: ICustomerStyle | null
}

export default function Error() {
    return (
        <div className="Error" data-testid="error">
            <div className="content">
                <h1 id="not-found-text">Ups... something went wrong :(</h1>
            </div>
        </div>
    )

}